/* RUB HUB GOLDEN RULE (2026-09-23): products tagged pre-order show "Pre-order" on every add-to-cart button. Liquid marks those buttons data-rh-preorder; this keeps the label when theme JS rewrites it. */
(function () {
  'use strict';
  var SKIP = /adding|added|sold out|unavailable|notify|thank/i;
  var ADD = /^(add to cart|add)( .*)?$/i;
  function label() { return (window.variantStrings && window.variantStrings.preOrder) || 'Pre-order'; }
  function fixButton(btn) {
    if (btn.disabled || btn.classList.contains('is-notify-me')) return;
    var L = label(), w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var t = (n.nodeValue || '').trim();
      if (!t || t === L || SKIP.test(t)) continue;
      if (ADD.test(t)) n.nodeValue = L;
    }
    var ti = btn.getAttribute('title');
    if (ti && ADD.test(ti.trim())) btn.setAttribute('title', L);
  }
  function fixAll() {
    var list = document.querySelectorAll('button[data-rh-preorder]');
    for (var i = 0; i < list.length; i++) fixButton(list[i]);
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fixAll(); });
  }
  function start() {
    fixAll();
    new MutationObserver(function () {
      if (document.querySelector('button[data-rh-preorder]')) queue();
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
